import React from "react";
import Countdown from 'react-countdown-now';
import moment from "moment";


export const Timer = ({ endDateTime, complete, css = {} }) => {
	if (!complete)
		return <Countdown
			date={endDateTime}
			// renderer={renderer}
			renderer={props => renderer({...props, endDateTime, css})}
		/>
	else return null;
}

const styles = {
	countdownMain: {
		position: 'absolute',
		right: 40,
		top: -67,
	},
	countdownWrapper: {
		display: "flex",
	},
	countdownItem: {
		color: "#111",
		fontSize: 20,
		display: "flex",
		alignItems: 'center',
		justifyContent: 'center',
		flexDirection: 'column',
		margin: 10,
		position: 'relative',
		width: 50,
		height: 50
	},
	countdownItemSpan: {
		color: "#333",
		fontSize: 6,
		fontWeight: 600,
		textTransform: 'uppercase'
	},
	countdownSvg: {
		position: 'absolute',
		top: 0,
		left: 0,
		width: 50,
		height: 50
	}

};

export const renderer = ({ total, days, hours, minutes, seconds, completed, endDateTime, css}) => {
	if (completed) {
		return <div style={{...styles.countdownMain, ...css}}>
			<p style={{
				color: "#fff",
				padding: "8px 8px",
				background: 'red',
				borderRadius: 5,
				marginRight: 20,
				display:'inline-block'
			}}>Over Due({moment(endDateTime).format('DD MMM YYYY, h:mm a')})</p>
		</div>;
	} else {
		const daysRadius = mapNumber(days, 30, 0, 0, 360);
		const hoursRadius = mapNumber(hours, 24, 0, 0, 360);
		const minutesRadius = mapNumber(minutes, 60, 0, 0, 360);
		const secondsRadius = mapNumber(seconds, 60, 0, 0, 360);

		// Render a countdown
		return (
			<div style={{...styles.countdownMain, ...css}}>
				<div style={styles.countdownWrapper}>
					{days > 0 && (
						<div style={styles.countdownItem}>
							<SVGCircle stly={styles.countdownSvg} radius={daysRadius} />
							{days}
							<span style={styles.countdownItemSpan}>days</span>
						</div>
					)}
					{hours > 0 && (
						<div style={styles.countdownItem}>
							<SVGCircle stly={styles.countdownSvg} radius={hoursRadius} />
							{hours}
							<span style={styles.countdownItemSpan}>hours</span>
						</div>
					)}
					{minutes > 0 && (
						<div style={styles.countdownItem}>
							<SVGCircle stly={styles.countdownSvg} radius={minutesRadius} />
							{minutes}
							<span style={styles.countdownItemSpan}>minutes</span>
						</div>
					)}
					{seconds > 0 ? (
						<div style={styles.countdownItem}>
							<SVGCircle stly={styles.countdownSvg} radius={secondsRadius} />
							{seconds}
							<span style={styles.countdownItemSpan}>seconds</span>
						</div>
					) : <div style={styles.countdownItem} />}
				</div>
			</div>
		);
	}
};

const SVGCircle = ({ radius, stly }) => (
	<svg style={stly}>
		<path fill="none" stroke="#333" strokeWidth="2" d={describeArc(25, 25, 23, 0, radius)} />
	</svg>
);


function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
	var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;

	return {
		x: centerX + (radius * Math.cos(angleInRadians)),
		y: centerY + (radius * Math.sin(angleInRadians))
	};
}

function describeArc(x, y, radius, startAngle, endAngle) {

	var start = polarToCartesian(x, y, radius, endAngle);
	var end = polarToCartesian(x, y, radius, startAngle);

	var largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

	var d = [
		"M", start.x, start.y,
		"A", radius, radius, 0, largeArcFlag, 0, end.x, end.y
	].join(" ");

	return d;
}

function mapNumber(number, in_min, in_max, out_min, out_max) {
	return (number - in_min) * (out_max - out_min) / (in_max - in_min) + out_min;
}
